 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import INTRODUCTION from '@/components/Introduction'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import TITLE_PAGE from '@/components/Title_Page'
 import BIBLE_VERSE from '@/components/Bible_Verse'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_ONE from '@/components/Chapter_One'
 import CHAPTER_TWO from '@/components/Chapter_Two'
 import CHAPTER_THREE from '@/components/Chapter_Three'
 import CHAPTER_FOUR from '@/components/Chapter_Four'
 import CHAPTER_FIVE from '@/components/Chapter_Five'
 import CHAPTER_SIX from '@/components/Chapter_Six'
 import CHAPTER_SEVEN from '@/components/Chapter_Seven'
 import CHAPTER_EIGHT from '@/components/Chapter_Eight'
 import CHAPTER_NINE from '@/components/Chapter_Nine'
 import CHAPTER_TEN from '@/components/Chapter_Ten'
 import CHAPTER_ELEVEN from '@/components/Chapter_Eleven'
 import CHAPTER_TWELVE from '@/components/Chapter_Twelve'
 import CHAPTER_THIRTEEN from '@/components/Chapter_Thirteen'
 import CHAPTER_FOURTEEN from '@/components/Chapter_Fourteen'
 import CHAPTER_FIFTEEN from '@/components/Chapter_Fifteen'
 import CHAPTER_SIXTEEN from '@/components/Chapter_Sixteen'
 import CHAPTER_SEVENTEEN from '@/components/Chapter_Seventeen'
 import CHAPTER_EIGHTEEN from '@/components/Chapter_Eighteen'
 import CHAPTER_NINETEEN from '@/components/Chapter_Nineteen'
 import CHAPTER_TWENTY from '@/components/Chapter_Twenty'
 import DEAR_READER from '@/components/Dear_Reader'
 import BPAMYREWARDS from '@/components/BPA-MyRewards'
 import BPAXLI_HISTORICAL from '@/components/BPA-xLI_Historical'
 import EXCERPT from '@/components/Excerpt'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_One",
 			"name" : "Chapter_One",
 			"component" : CHAPTER_ONE
 		},
 		{
 			"path" : "/Chapter_Two",
 			"name" : "Chapter_Two",
 			"component" : CHAPTER_TWO
 		},
 		{
 			"path" : "/Chapter_Three",
 			"name" : "Chapter_Three",
 			"component" : CHAPTER_THREE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js